import store from '@/store';
import { leaseType } from '@/util/dictList.js';
export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  // rowKey: 'index',
  column: [
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchOrder: 996,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      type: 'input',
      search: true,
      searchOrder: 995,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      type: 'input',
    },
    {
      label: '租期',
      prop: 'tenancy',
      type: 'select',
      // searchOrder: 991,
      // search: true,
      formatter: (val, value) => {
        return value ? value + '期' : '-';
      },
      dicData: leaseType,
    },
    {
      label: '每期租金',
      prop: 'lendingAmountPer',
      type: 'input',
      // searchOrder: 993,
      // search: true,
      slot: true,
    },
    {
      label: '客户期数',
      prop: 'currentPeriod',
      type: 'input',
      formatter: (val, value) => {
        return value ? `${value} (${val.customerRepaymentDate})` : '-';
      },
    },
    {
      label: '代理商期数',
      prop: 'agentCurrentTenancyStr',
      type: 'input',
      formatter: (val, value) => {
        return value ? `${value} (${val.agentRepaymentDate})` : '-';
      },
    },
    {
      label: '是否代偿',
      prop: 'compensationStatusStr',
      type: 'select',
      search: true,
      searchOrder: 666,
      dicData: [
        { label: '否', value: 2 },
        { label: '是', value: 3 },
      ],
    },
    {
      label: '入账日期',
      prop: 'postingDate',
      type: 'input',
    },
    {
      label: '主键id',
      prop: 'id',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      search: true,
      searchOrder: 555,
    },
    // {
    //   label: '手机号',
    //   prop: 'phoneNumber',
    //   type: 'input',
    // },
    // {
    //   label: '身份证',
    //   prop: 'cardNo',
    //   type: 'input',
    // },
    // {
    //   label: '租赁人属性',
    //   prop: 'tenantAttribute',
    //   type: 'input',
    // },
    // {
    //   label: '代理商类型',
    //   prop: 'agentType',
    //   type: 'select',
    //   search: true,
    //   searchOrder: 998,
    //   width: 90,
    //   dicData: [
    //     {
    //       label: '直管',
    //       value: 1,
    //     },
    //     {
    //       label: '代管',
    //       value: 2,
    //     },
    //   ],
    // },
    // {
    //   label: '代管比例',
    //   prop: 'manageProportion',
    //   type: 'input',
    //   formatter: (val, value) => {
    //     return value ? value : '-';
    //   },
    // },
    // {
    //   label: '是否省代',
    //   prop: 'provincialRepresentative',
    //   type: 'select',
    //   dicData: [
    //     {
    //       label: '是',
    //       value: 1,
    //     },
    //     {
    //       label: '否',
    //       value: 0,
    //     },
    //   ],
    // },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      dicData: store.getters.porductTypes,
      hide: true,
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      type: 'select',
      search: true,
      searchOrder: 998,
      searchMultiple: true,
      hide: true,
      dicData: store.getters.porductTypes,
    },
    // {
    //   label: '租付类型',
    //   prop: 'rentPayTypeStr',
    //   type: 'select',
    // },
    // {
    //   label: '租率',
    //   prop: 'rate',
    //   type: 'select',
    //   search: true,
    //   searchOrder: 992,
    //   dicData: [],
    //   props: {
    //     label: 'lable',
    //     value: 'rate',
    //   },
    // },
    // {
    //   label: '本期应还滞纳金',
    //   prop: 'duePeriodOverdueFine',
    //   type: 'input',
    // },
    // {
    //   label: '当前所处状态',
    //   prop: 'currentStatusString',
    //   type: 'input',
    // },
    // {
    //   label: '是否抵扣',
    //   prop: 'deductionStatusStr',
    //   type: 'select',
    //   // dicData: [
    //   //   {
    //   //     label: '是',
    //   //     value: 1,
    //   //   },
    //   //   {
    //   //     label: '否',
    //   //     value: 0,
    //   //   },
    //   // ],
    // },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 999,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    // {
    //   label: '入账状态',
    //   prop: 'computeRepaymentProcessStatus',
    //   type: 'select',
    //   formatter: (val, value) => {
    //     if (value === 1) {
    //       return '入账中';
    //     }
    //     // if (value === 2) {
    //     //   return '部分还款';
    //     // }
    //     if (value === 3) {
    //       return '驳回';
    //     }
    //     // return '';
    //   },
    // },
    // {
    //   label: '还租状态',
    //   prop: 'repaymentType',
    //   type: 'select',
    //   search: true,
    //   hide: true,
    //   showColumn: false,
    //   dicData: [
    //     {
    //       label: '入账中',
    //       value: 1,
    //     },
    //     // {
    //     //   label: '代偿',
    //     //   value: 2,
    //     // },
    //     // {
    //     //   label: '抵扣',
    //     //   value: 3,
    //     // },
    //     {
    //       label: '驳回',
    //       value: 4,
    //     },
    //   ],
    // },
  ],
};

//根据角色权限来展示
export const jurisdictionDifferentiate = {
  finance: [
    {
      title: '租赁人',
      value: 'name',
      order: 1,
    },
    {
      title: '车牌号',
      value: 'carFirstNumber',
      order: 2,
    },
    {
      title: '所属代理商',
      value: 'businessDeptName',
      order: 3,
    },
    {
      title: '产品类型',
      value: 'rentType',
      order: 4,
    },
    {
      title: '租期',
      value: 'tenancy',
      order: 5,
    },
    {
      title: '每期租金',
      value: 'lendingAmountPer',
      order: 6,
    },
    {
      title: '客户期数',
      value: 'currentPeriod',
      order: 7,
    },
    {
      title: '代理商期数',
      value: 'agentCurrentTenancyStr',
      order: 8,
    },
    {
      title: '是否代偿',
      value: 'compensationStatusStr',
      order: 9,
    },
    // {
    //   title: '入账状态',
    //   value: 'computeRepaymentProcessStatus',
    //   order: 9,
    // },
  ],
};
